import React from 'react';
import { cn } from '@/lib/utils';

export const Card: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => (
  <div className={cn("bg-white rounded-lg shadow-md", className)}>
    {children}
  </div>
);

export const Badge: React.FC<{
  className?: string;
  children: React.ReactNode;
  variant?: 'default' | 'destructive';
}> = ({ className, children, variant = 'default' }) => (
  <span className={cn(
    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
    variant === 'destructive' ? "bg-red-100 text-red-700" : "bg-gray-100 text-gray-700",
    className
  )}>
    {children}
  </span>
);

export const Button: React.FC<{
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  disabled?: boolean;
}> = ({ className, children, onClick, variant = 'default', size = 'default', disabled }) => {
  const baseStyles = "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

  const variants = {
    default: "bg-[#fe4a0b] text-white hover:bg-[#fe4a0b]/90",
    outline: "border border-gray-300 bg-white hover:bg-gray-50",
    ghost: "hover:bg-gray-100"
  };

  const sizes = {
    default: "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3",
    lg: "h-11 rounded-md px-8",
    icon: "h-10 w-10"
  };

  return (
    <button
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export const Progress: React.FC<{ value: number; className?: string }> = ({ value, className }) => (
  <div className={cn("relative h-2 w-full overflow-hidden rounded-full bg-gray-200", className)}>
    <div
      className="h-full bg-[#fe4a0b] transition-all duration-300 ease-in-out"
      style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
    />
  </div>
);